module.exports = __webpack_public_path__ + "images/video-play-icon-ff5edf.png";